var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11572_38631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1665 7.00033C1.1665 7.76637 1.31739 8.52491 1.61054 9.23265C1.90369 9.94038 2.33337 10.5834 2.87505 11.1251C3.41672 11.6668 4.05978 12.0965 4.76752 12.3896C5.47525 12.6828 6.23379 12.8337 6.99984 12.8337C7.76588 12.8337 8.52442 12.6828 9.23216 12.3896C9.93989 12.0965 10.583 11.6668 11.1246 11.1251C11.6663 10.5834 12.096 9.94038 12.3891 9.23265C12.6823 8.52491 12.8332 7.76637 12.8332 7.00033C12.8332 6.23428 12.6823 5.47574 12.3891 4.76801C12.096 4.06027 11.6663 3.41721 11.1246 2.87554C10.583 2.33386 9.93989 1.90418 9.23216 1.61103C8.52442 1.31788 7.76588 1.16699 6.99984 1.16699C6.23379 1.16699 5.47525 1.31788 4.76752 1.61103C4.05978 1.90418 3.41672 2.33386 2.87505 2.87554C2.33337 3.41721 1.90369 4.06027 1.61054 4.76801C1.31739 5.47574 1.1665 6.23428 1.1665 7.00033Z",
    stroke: "#9872FE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.125H7V9.625",
    stroke: "#9872FE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.625H8.75",
    stroke: "#9872FE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66699V3.79199",
    stroke: "#9872FE",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11572_38631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/Information Circle.4f34ce2b.svg";
export { ForwardRef as ReactComponent };